import React from 'react';
import MapChart from './MapChart';
import BarChart from './Bar';
import Video from './Video';
import './App.scss';

const path = process.env.PUBLIC_URL

function App() {
  return (
    <div className="App">
      <h1 className='title'><img src={path + '/images/title.png'} alt="title" /></h1>
      <div className='text__container date'>更新至：2025年1月1日</div>
      <div className="text__container">
        <p>2022年4月，法国总统马克龙迎着欧盟盟歌《欢乐颂》的旋律，意气风发走上埃菲尔铁塔下的战神广场。他刚在总统大选第二轮选举中获得55%选票，击败第二次挑战他的极右派领袖马琳·勒庞。马克龙感谢选民阻止“极右翼”扩张，又向勒庞的支持者喊话，说自己要做“所有法国人的总统”。</p>
        <p>彼时，各国刚从新冠疫情的阴霾中走出，人们迫不及待走向世界，重拾旅行的乐趣；靠政府补贴的日子结束了，各行各业都在抢夺人才；特朗普的乖张成为历史，美国和欧洲巩固了伙伴关系；俄罗斯大军的入侵奇迹般止于基辅城下。那股从欧洲难民危机而起，伴随2016年英国脱欧公投和特朗普当选到来的极右浪潮，好像戛然而止：自由贸易、中道政治、国际合作似乎都将回归。</p>
        <p>乐观情绪掩盖了不少隐忧。2022年的总统大选中，马克龙在首轮投票只获得28%选票，紧随其后的是极右派勒庞的23%，和极左派候选人梅郎雄的22%。换言之，持激进变革立场的选民已接近甚至超越半数，远胜中间派。美国总统拜登同样赢得吃力，特朗普在任期最后一年应对新冠疫情失据，以微弱劣势败选，但右翼“基本盘”并未崩塌。</p>
        <p>2024年，强烈的“亡国感”笼罩着大西洋两岸的自由派。法国人不敢想像曾经一手创立并领导欧盟的法国，会走回民族主义老路；百年的共和主义传统，似乎很快要被种族主义取代。民主党选民眼见拜登在6月首次辩论后令人失望的表现，也陷入集体焦虑：撤换拜登的声音从布鲁克林公寓的沙发上，一路传到《纽约时报》的编辑部。</p>
        <p>当旅行者自由地穿州越界，因疫情暂停数年的人口流动恢复，当地人对移民和难民“入侵”的恐惧回来了。当打工人可以轻易找到工作，缺工问题也来了，伴随的是顽固的通货膨胀。当俄罗斯的“闪电战”成为“持久战”，依仗强大国力消耗着自由世界援助乌克兰的耐心和信心。当特朗普再次发起挑战，却照旧口出狂言，这不禁让很多人担忧，极右浪潮，卷土重来了吗？</p>
        <p>但左翼亦不甘人后。根据民调，英国工党即将在暌违十四年后重新执政。曾被认为是欧洲坚定的保守堡垒的波兰，在去年迎来了亲欧派的新总理。刚刚过去的印度大选中，民族主义者莫迪遭遇了执政生涯以来可能最大的挫败，仅以微弱优势保住执政地位。而法国议会选举中，虽极右翼政党强劲领先，左翼政党得票数也紧随其后。</p>
        <p>吸票能力往往反映关注度和认可度的高低，却不代表微弱的声音不重要。在左右政党崛起之际，中间地带的选民是否感到无所适从？他们正在失去必要的政治影响力吗？</p>
        <p>包括这些备受瞩目的“选举大国”在内，2024年，全球有64个国家和欧洲议会陆续举行大选，涉及逾40亿人，超过全球人口的一半，这在人类历史上是第一次。虽然看似世界上大多数人都能够参与投票，但是各国选民手中的选票的有效性，其民主、公平程度却有天壤之别，因此选举对各国公民的意义也不尽相同。歪脑跟踪了其中57个国家的选举进程和结果，结合独立研究机构的各国政党政治的分析数据，为读者探测2024全球选情对未来几年政治政策的影响。</p>
        <p>选民们共同形塑的浪潮，会将世界推向何方？</p>
        <h2>世界选举地图</h2>
        <p>歪脑在世界地图上按人口比例标注出了所有于2024年举行大选的国家，圆圈的大小代表相应人口规模的大小，并用颜色变化来反映民主指数、公正自由选举指数等数据，帮助读者从不同角度观测各国的选举公正性和民主程度。</p>
        <p>在这些国家中，居住在完全民主的国家的人口约3.9亿，不到选举国总人口的十分之一（9.8%）。而它们的民主指数、公正自由选举指数也名列前茅。台湾民进党赖清德当选总统，随即面临中国施压的挑战；法国议会选举中，极右翼政党“国民联盟”成为最大势力，马克龙的时代已成为过去；英国首相苏纳克领导的保守党的支持率一路下降，而对手工党势头正盛；美国总统大选，特朗普卷土重来，击败贺锦丽再入白宫，更引起世界广泛关注。</p>
        <p>2024年，有15个被认为是威权政权的国家也举行全国大选，居住在这些威权国家的人口，将近选举国家总人口的五分之一（19.2%）。阿塞拜疆总统阿利耶夫在没有反对党参加的大选中以92.10%的得票率连任总统；俄罗斯普京以87%的得票率第五次成为俄罗斯总统；伊朗在总统莱西坠机身亡后举行大选，投票率却再创新低，呼吁大规模改革的候选人被禁止参选。</p>
      </div>
      <MapChart />
      <div className="text__container">
        <h2>选举前后各国执政党的政策走向</h2>
        <p>这些国家的民意发生了什么改变？选举对国家政策产生了什么影响？根据瑞典哥德堡大学的知名研究机构 V-Dem（Varieties of Democracy 多元民主）发布的各国政治党派的调查研究数据，歪脑选取了其中比较有代表性的几个指数，比较各国在选举前后执政党派的政策走向，管窥2024的选举对各国发展可能带来的影响。</p>       
      </div>
      <BarChart />
      <div className="text__container">
        <h2>选举中的面孔</h2>
        <p>歪脑邀请来自多个国家的选民通过视频分享他们参与选举的现场，聊聊对这次投票的感想、心仪的政党或候选人，以及他们所关心的社会和国家议题。</p>
        <p>在当地，人们怀着不同的期待来到投票站，有的人认为投票是公民的职责，相信自己的选择会影响国家的未来；有的人希望自己支持的政党能够执政，改善和自身权利息息相关的社会议题；也有的人对体制充满失望，并不认为投票能够改变什么。身处于不同的环境，选举对个人的意义往往千差万别，但是人们对一个安全、自由、公平、富裕国家的向往是相通的，这也是促使我们参与政治的理由。</p>
      </div>
      <Video />
      <div className="text__container method">
        <h2>方法</h2>
        <p>歪脑从<a href="https://www.electionguide.org/" target="_blank" rel="noreferrer">国际选举制度基金会</a>（International Foundation for Electoral Systems）收集了2024年计划举行全国规模选举的国家及相关选举信息，包括人口、选举类型、时间和结果等。针对各国选举制度和政党政策的评估，歪脑引用了英国《经济学人》发表的《<a href="https://www.eiu.com/n/campaigns/democracy-index-2023/" target="_blank" rel="noreferrer">民主指数2023</a>》报告和瑞典哥德堡大学的研究机构 V-Dem（Varieties of Democracy 多元民主）发表的<a href="https://www.v-dem.net/data/the-v-dem-dataset/" target="_blank" rel="noreferrer">公正自由选举指数</a>和<a href="https://www.v-dem.net/data/v-party-dataset/" target="_blank" rel="noreferrer">各国政党调查数据库</a>。</p>
        <h3>选举数量</h3>
        <p>据国际选举制度基金会统计，2024年全球一共有77个国家举行全国范围的投票选举，这些国家的人口总和超过了地球人口的一半。歪脑把焦点放在各国的政府首脑和立法机构选举。大洋洲的基里巴斯、图瓦卢、帕劳和欧洲的圣马力诺由于缺少相关政治党派信息和独立研究机构的评估，最后没有包括在数据呈现和统计中。欧洲议会选举虽然对地区和世界政治经济有深远影响，但是由于选举特殊，涉及多国众多政治团体代表，不方便包括在数据呈现和分析中。因此，图表主要呈现除此之外的60个选举国家的相关数据。</p>
        <h3>政权分类</h3>
        <p>根据英国《经济学人》的民主指数，各国政权按民主程度分为完全民主、有缺陷的民主、混合政权和独裁政权。</p>
        <p>完全民主国家的公民自由和基本政治自由不仅受到尊重，而且还通过有利于民主原则蓬勃发展的政治文化得到加强。这些国家拥有有效的政府制衡体系、独立司法机构、充分运作的政府以及多元化和独立的媒体。这些国家在民主运作方面存在的问题有限。</p>
        <p>有缺陷的民主国家是指选举公平、自由、基本公民自由受到尊重但可能存在问题（例如侵犯媒体自由以及对政治反对派和批评者进行轻微镇压）的国家。这些国家在其他民主方面可能存在重大缺陷，包括政治文化不发达、政治参与水平低以及治理运作方面存在问题。</p>
        <p>混合政权是经常发生选举舞弊的国家，阻碍了它们成为公平和自由的民主国家。这些国家普遍存在政府对政治反对派施加压力、司法不独立、腐败泛滥、媒体受到骚扰和压力、法治软弱等问题，以及比有缺陷的民主国家更明显的缺陷，如政治文化不发达、水平低下等。政治参与以及治理运作中的问题。</p>
        <p>独裁政权是政治多元化不存在或受到严重限制的国家。这些国家通常是绝对君主制或独裁国家，可能有一些传统的民主制度，但意义不大，侵犯和滥用公民自由很常见。如果举行选举的话，也是不公平或自由的选举，包括虚假选举。媒体往往是国有或由与统治政权有联系的团体控制，司法机构不独立，审查和压制政府批评很常见。</p>
        <p>《经济学人》没有对马尔代夫、索马里兰、所罗门群岛和南苏丹的民主制度评分，所以也这些国家也没有民主排名和政权类型的信息。</p>
        <h3>公正自由选举指数和政党态度</h3>
        <p>V-Dem 常年调查采集各国政治相关领域专家对该国选举制度及操作过程和主要政党的评价，统计发表“公正自由选举”指数（Fair and Free Election Index）和政党数据库(V-Party Database)。</p>
        <p>公正自由选举指数更新至2023年，是对各国的选举制度和实际操作程序举行了综合评价，关注选举管理是否独立，人力物力配备是否合理，是否出现选民注册舞弊、系统性的违规行为、政府威胁反对党、收买选票和选举暴力等。</p>
        <p>V-Dem 政党数据库更新至2020年，不包括近年成立或改组的政党的数据。V-Dem对政党意识形态和政策态度的评分，综合了各国相关领域多名专家的评估，且仅反映专家当时对各政党的评估，所以歪脑在此展示的各国选举前后政策走向的评估仅供读者参考。</p>
        
      </div>
      <div className="text__container method">
        <h2>Credit</h2>
        <ul>
          <li><span>数据编辑：</span>Paul Wang</li>
          <li><span>文字编辑：</span>Mimi Qin & 张震</li>
          <li><span>视频统筹：</span>Rachel Chen</li>
          <li><span>视频编辑：</span>Hedi Chen & Lu Liu & Olivia Lenee</li>
          <li><span>网页制作：</span>Vic Kim</li>
          <li><span>总编：</span>Alex Zhang</li>
        </ul>
      </div>
    </div>
  );
}

export default App;
